import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import {withStyles} from '@material-ui/core';
import {IsLP_MP_SP_T} from "my-styles/media/media";

const styles = {
    notchedOutline: {
        borderWidth: "0 !important"
    }
}

function AutocompleteComboBox(props) {
    return (
        <table className="inputBox marginTopBottomXSmall horizontalFullScreen"
               style={{backgroundColor: props.backgroundColor ? props.backgroundColor : "var(--gray_1)"}}>
            <tbody className="full">
            <tr className="full">
                {props.icon &&
                <td className="fullHeight">
                    {props.icon}
                </td>
                }
                <td className="full">
                    <Autocomplete

                        options={props.options}
                        onChange={props.onChange}

                        value={props.defaultValue}
                        getOptionLabel={props.getOptionLabel ? props.getOptionLabel : (option) => option.name || ""}
                        getOptionSelected={(option, value) => option.id === value.id}
                        getOptionDisabled={(option) => option.status===false}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                key={props.value}
                                onChange={props.onTextChange}
                                placeholder={props.placeholder}
                                InputProps={{
                                    ...params.InputProps,
                                    classes: props.classes,
                                    style: {
                                        padding: "0",
                                        height: props.height ? props.height : "100%",
                                        fontSize: props.fontSize ? props.fontSize :
                                            (IsLP_MP_SP_T() ? "medium" : "small")
                                    }
                                }}
                                variant="outlined"/>}
                    />
                </td>
            </tr>
            </tbody>
        </table>
    )
}

export default withStyles(styles)(AutocompleteComboBox)